import React from "react";

import { FarmerType, useNavigate, useTranslation } from "utils";

import { Button, Flex, Form } from "components";

interface SignupButtonsProps {
  loading: boolean;
  farmerType: FarmerType;
  onClick?: () => void;
  submitDisabled?: boolean;
}

export const SignupButtons: React.FC<SignupButtonsProps> = ({ loading, onClick, farmerType, submitDisabled = false }) => {
  const { t } = useTranslation("signinup");
  const navigate = useNavigate();

  return (
    <Flex vertical gap={16} className="center">
      {onClick ? (
        <Button dataTestId="sign-up-button-intro" type="primary" disabled={loading} loading={loading} onClick={onClick}>
          {t("signup.buttons.createAccount")}
        </Button>
      ) : (
        <Form.Item>
          <Button dataTestId="sign-up-button" type="primary" htmlType="submit" disabled={loading || submitDisabled} loading={loading}>
            {t("signup.buttons.createAccount")}
          </Button>
        </Form.Item>
      )}
      <Button
        type="secondary"
        mixpanelText={t("signup.buttons.signin")}
        dataTestId="sign-in-button"
        disabled={loading}
        onClick={() => navigate(`/sign-in${farmerType === "default" ? "" : `/${farmerType}`}`)}
      >
        {t("signup.buttons.signin")}
      </Button>
    </Flex>
  );
};
